<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">System Configuration</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-settings" />
            System Configuration
          </b-breadcrumb-item>
          <b-breadcrumb-item>
            Script
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
      <CCol class="col-5">
        <CButton color="primary" class="float-right mt-2" @click="createScript">
          Create <FaIcon icon="plus" />
        </CButton>
      </CCol>
    </CRow>
    <CCard class="custom-card" v-if="$helper.isRole($availRoles['HO'])">
      <CCardBody class="px-0 pb-0">
        <CRow>
          <CCol class="ml-5">
            <CForm>
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-select v-model="table.filterType" :options="table.filterOptions" @change="onChangeFilterType"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <b-form-select v-if="table.filterType == 'transType'" v-model="table.filterValue" :options="table.filterValueTransTypeOptions" style="min-width: 206.5px;"></b-form-select>
                  <b-form-select v-else-if="table.filterType == 'status'" v-model="table.filterValue" :options="table.filterValueStatusOptions" style="min-width: 206.5px;"></b-form-select>
                  <b-form-input maxlength="50" v-else type="text" placeholder="Search" v-model="table.filterValue"></b-form-input>
                </b-input-group-prepend>
                <b-input-group-append>
                  <CButton size="sm" color="primary" style="color: white;" class="btn-icon mr-2 custom-button-action" type="submit" @click="filterTable">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-4" v-if="$helper.isRole($availRoles['HO'])">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="table.items"
              :fields="table.fields"
              :busy="!table.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onSortChanged"
            >
              <template slot="empty">
                <div v-if="!table.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
              <template #cell(transType)="row">
                {{ row.value == 'F' ? 'Fiducia' : 'Roya' }}
              </template>
              <template #cell(status)="row">
                  <CBadge v-if="row.value == 'Y'"
                    color="success"
                  > AKTIF
                  </CBadge>
                  <CBadge v-else
                    color="danger"
                  > NONAKTIF
                  </CBadge>
              </template>
              <template #cell(action)="row">
                <CButton size="sm" color="warning" style="color: white;" @click="editDocument(row.item.paramId)" class="btn-icon mr-2 custom-button-action">
                  <CIcon name="cil-pencil" />
                </CButton> 
                <CButton size="sm" color="danger" class="mr-2 custom-button-action" style="width:5.5rem" @click="toggleStatus(row.index)" :disabled="row.item.isToggling" v-if="row.item.status == 'Y'">
                  <b-spinner small v-if="row.item.isToggling" />
                  <span v-else>Deaktivasi</span>
                </CButton> 
                <CButton size="sm" color="success" class="mr-2 custom-button-action" style="width:5.5rem" @click="toggleStatus(row.index)" :disabled="row.item.isToggling" v-else>
                  <b-spinner small v-if="row.item.isToggling" />
                  <span v-else>Aktivasi</span>
                </CButton> 
                <CButton size="sm" color="danger" style="color: white;" @click="showDeleteModal(row.item.paramId, row.item.transType, row.item.paramDesc)" class="btn-icon mr-2 custom-button-action">
                  <CIcon name="cil-trash" />
                </CButton> 
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="table.totalRows" :page="table.currentPage" :options="tablePageOptions" @limit-change="onLimitChange" @page-change="onPageChange" />
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{errorTitle}}</h5></div>
      <div class="body">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton v-if="errorLogout" color="primary" @click="$router.push({name: 'Login'})">Login</CButton>
        <CButton v-else color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>

    <CModal :closeOnBackdrop="false" :show.sync="showDeleteScriptModal" :centered="true">
      <div slot="header"><h5>Konfirmasi Delete Script</h5></div>
      <div class="body">
        <CRow class="mb-2">
          <CCol>
            Apakah Anda yakin ingin menghapus Script berikut?
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            ID
          </CCol>
          <CCol md="8" sm="7">
            : {{ deleteScript.paramId }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Tipe Transaksi
          </CCol>
          <CCol md="8" sm="7">
            : {{ deleteScript.transType == 'F' ? 'Fiducia' : 'APHT' }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Deskripsi
          </CCol>
          <CCol md="8" sm="7">
            : {{ deleteScript.paramDesc }}
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="primary" @click="showDeleteScriptModal = false">Batal</CButton>
        <CButton class="ml-2" color="danger" @click="confirmDeleteScript" :disabled="isLoading.deleteScript">
          <b-spinner small type="grow" v-if="isLoading.deleteScript" /> 
          {{ isLoading.deleteScript ? 'Sedang diproses...' : 'Ya' }}
        </CButton>
      </div>
    </CModal>
  </CContainer>
</template>

<script>
export default {
  name: 'ConfigScriptList',
  data() {
    return {
      showErrorModal: false,
      errorLogout: false,
      errorLabel: 'Unexpected Error',
      errorTitle: 'Error!',
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      table: {
        isLoaded: false,
        fields: [
          {key: "paramId", label: "ID", sortable: true},
          {key: "transType", label: "Tipe Transaksi", sortable: true},
          {key: "paramDesc", label: "Deskripsi", sortable: true},
          {key: "status", label: "Status", sortable: true},
          {key: "action", label: "Aksi", sortable: false}
        ],

        items: [],

        filterType: "paramId",
        filterOptions: [
          { value: "paramId", text: "ID" },
          { value: "transType", text: "Tipe Transaksi" },
          { value: "paramDesc", text: "Deskripsi" },
          { value: "status", text: "Status" }
        ],
        filterValue: "",
        filterValueTransTypeOptions: [
          { value: "F", text: "Fiducia" },
          { value: "R", text: "Roya" },
        ],
        filterValueStatusOptions: [
          { value: "Y", text: "Aktif" },
          { value: "N", text: "Nonaktif" },
        ],

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },

      isLoading: {
        deleteScript: false,
      },

      showDeleteScriptModal: false,
      deleteScript: {
        paramId: 0,
        transType: "F",
        paramDesc: '',
      },
    }
  },
  methods: {

    toggleStatus(idx) {
      let postUrl = "/paramScript/toggleStatus"
      let payload = new FormData()
      payload.append("paramId", this.table.items[idx].paramId)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO'])){
        // use index to properly update table row after manipulation
        this.table.items[idx].isToggling = true
        this.$axios.post(postUrl, payload).then(response => {
          if(response.status == 200){
            if(this.table.items[idx].status == "Y") this.table.items[idx].status = "N"
            else this.table.items[idx].status = "Y"
            this.$helper.toastSuccess(this, (this.table.items[idx].status == "Y" ? "Aktivasi" : "Deaktivasi") + " Script Berhasil! " + (response.data.reason ? response.data.reason : ""))
          }
          else{
            this.$helper.toastError(this, "Ubah Status Script Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Ubah Status Script Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Ubah Status Script Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.table.items[idx].isToggling = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    filterTable(event) {
      event.preventDefault()

      this.getTableItems(this.table.currentPage)
    },

    createScript() {
      this.$router.push({ name: 'Config Script Add' })
    },

    editDocument(scriptId) {
      this.$router.push({ name: 'Config Script Edit', params: { scriptId: scriptId } })
    },

    showDeleteModal(paramId, transType, paramDesc) {
      this.deleteScript.paramId = paramId
      this.deleteScript.transType = transType
      this.deleteScript.paramDesc = paramDesc

      this.showDeleteScriptModal = true
    },

    confirmDeleteScript() {
      this.isLoading.deleteScript = true
      let processUrl = "/paramScript/delete";
      let data = new FormData();
      data.set('paramId', this.deleteScript.paramId);
      this.$axios.post(processUrl, data).then((response) => {
        if (response.status === 200){
          this.$helper.toastSuccess(this, "Delete Script sukses!")
          this.showDeleteScriptModal = false
        } else {
          this.$helper.toastError(this, "Delete Script Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Delete Script Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Delete Script Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading.deleteScript = false

        if(this.$helper.isRole(this.$availRoles['HO'])){
          this.getTableItems(this.table.currentPage)
        }
      })
    },
  
    onSortChanged(ctx) {
      this.table.sort.by = ctx.sortBy
      this.table.sort.desc = ctx.sortDesc
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.getTableItems(this.table.currentPage)
      }
    },

    onChangeFilterType() {
      if (this.table.filterType == "transType") {
        this.table.filterValue = "F"
      } else if (this.table.filterType == "status") {
        this.table.filterValue = "Y"
      } else{
        this.table.filterValue = null
      }
    },

    onLimitChange(newPerPage) {
      this.table.perPage = newPerPage
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.getTableItems()
      }
    },
  
    onPageChange(newPage) {
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.getTableItems(newPage)
      }
    },

    getTableItems(page = 1) {
      this.table.isLoaded = false
      this.table.items = []
      if(isNaN(page)) {
        this.table.currentPage = 1
      }
      else {
        this.table.currentPage = page
      }
      // URL builder
      let getUrl = "/paramScript/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.table.currentPage - 1, this.table.perPage)
      if(!this.$helper.isEmpty(this.table.filterValue)) {
        params['filterType'] = this.table.filterType
        params['filterValue'] = this.table.filterValue
      }
      if(this.table.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.table.sort, params)
      }
      
      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          sessionStorage.setItem("filterConfigScriptType", this.table.filterType)
          sessionStorage.setItem("filterConfigScriptValue", this.table.filterValue)
          this.table.items = response.data.data.data.map(obj => {
            obj.isToggling = false

            return obj
          })
          this.table.totalRows = response.data.data.totalElements
          this.table.totalPages = response.data.data.totalPages
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "List Script Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "List Script Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "List Script Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.table.isLoaded = true
      })
    },
  
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.errorTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      if (this.errorLabel.toLowerCase().includes('token expired')){
        this.errorLogout = true;
      }
      this.showErrorModal = true;
    },

  },

  created(){
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterConfigScriptType"))){
      this.table.filterType = sessionStorage.getItem("filterConfigScriptType")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterConfigScriptValue"))){
      this.table.filterValue = sessionStorage.getItem("filterConfigScriptValue")
    }
    this.getTableItems()

    if (this.$store.state.toast) {
      this.$helper.toastSuccess(this, this.$store.state.toastMsg)
      this.$store.commit('set', ['toast', false])
      this.$store.commit('set', ['toastMsg', ''])
    }
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>